import * as React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { classNames } from '@core/utils/functions/class-names';
import { NextImage } from '@research-api/utils/api/ghost/ghost-interfaces';
import ImageWithFallback from '@core/components/display/images/ImageWithFallback';

type ImageSliderProps = {
    imageUrls: NextImage[];
    className?: string;
};

const ImageSlider = (props: ImageSliderProps) => {
    const { imageUrls, className } = props;
    const [viewportRef] = useEmblaCarousel({ loop: false }, [Autoplay()]);

    return (
        <div className={classNames('relative lg:h-[700px] w-full', className)}>
            <div className="overflow-hidden w-full" ref={viewportRef}>
                <div className="embla__container flex">
                    {imageUrls.map((image, index) => (
                        <div className="embla__slide flex" key={image.url}>
                            <ImageWithFallback
                                src={image.url}
                                alt={`Image ${index}`}
                                width={image.dimensions.width}
                                height={image.dimensions.height}
                                className="object-cover w-full max-h-[700px]"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ImageSlider;
